import { render, staticRenderFns } from "./factoryLabel.vue?vue&type=template&id=57f81a3e&scoped=true"
import script from "./factoryLabel.vue?vue&type=script&lang=js"
export * from "./factoryLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f81a3e",
  null
  
)

export default component.exports